import { IonContent, IonPage } from "@ionic/react";
import { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ActiveCallView } from "@/components/communications/active-call-view";
import { leaveAppEntry } from "@/lib/history-entry";
import { routeTemplates } from "@/lib/routes";
import { useVoice } from "@/lib/twilio/voice-context";

export function ActiveCallPage() {
  const history = useHistory();
  const { activeCall } = useVoice();

  // Auto-pop when the call ends, as IncomingCallPage does once its invite is
  // gone, so the user doesn't get stuck on an empty page.
  useEffect(() => {
    if (activeCall) {
      return;
    }
    if (history.location.pathname !== routeTemplates.app.activeCall) {
      return;
    }
    leaveAppEntry(history, "/chats");
  }, [activeCall, history]);

  const handleMinimise = useCallback(() => {
    leaveAppEntry(history, "/chats");
  }, [history]);

  return (
    <IonPage>
      <IonContent fullscreen>
        <ActiveCallView onMinimise={handleMinimise} />
      </IonContent>
    </IonPage>
  );
}
